module.exports = __webpack_public_path__ + "01_veryshort_black.3d5f5eed.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/01_veryshort_black.png
// module id = hHzw
// module chunks = 0